import moment from "moment-jalaali";

export const formatDateToJalali = (date) => {
  if (date) {
    return moment(date).format("jYYYY-jMM-jDD");
  }

  return "";
};
